import { Note } from '../../../apis/types'
import NoteItem from './NoteItem'

interface CallsPanelProps {
  calls: Note[]
  callRequestPhase: { kind: 'idle' } | { kind: 'in-progress' } | { kind: 'failed' }
  totalCallCount: number
}

const CallsPanel: React.FC<CallsPanelProps> = ({ calls, callRequestPhase, totalCallCount }) => {
  if (callRequestPhase.kind === 'in-progress') {
    return (
      <div className="py-8 text-center text-slate-500 dark:text-slate-400" role="status">
        Loading Salesforce calls…
      </div>
    )
  }

  if (callRequestPhase.kind === 'failed') {
    return (
      <div className="py-8 text-center text-red-500 dark:text-red-400" role="alert">
        Failed to load Salesforce calls. Please try again.
      </div>
    )
  }

  if (calls.length === 0) {
    return (
      <div className="py-8 text-center text-slate-500 dark:text-slate-400" role="status">
        No Salesforce call notes for this tenant.
      </div>
    )
  }

  return (
    <div className="space-y-0">
      <div className="mb-2 text-xs text-slate-500 dark:text-slate-400" role="status">
        {totalCallCount} call{totalCallCount !== 1 ? 's' : ''} (newest first)
      </div>
      {calls.map((note, index) => (
        <NoteItem
          key={note.cuid}
          note={note}
          isLast={index === calls.length - 1}
          canModify={false}
          onUpdate={async () => {}}
          onDelete={async () => {}}
          onTogglePin={async () => {}}
        />
      ))}
    </div>
  )
}

export default CallsPanel
